<template>
  <pt-goods-qr-code-detail class="pt-goods-qr-code-detail__page"  :id="id"></pt-goods-qr-code-detail>
</template>

<script>
import PtGoodsQrCodeDetail from 'cps/mall-manage/pt-goods-qr-code/pt-goods-qr-code-detail/withData'
export default {
  name: 'pt-goods-qr-code-detail__view',
  components: {
    'pt-goods-qr-code-detail': PtGoodsQrCodeDetail
  },
  props: {
    id: {
      type: String,
      default: null
    }
  }
}
</script>
